import service from "@/store/services/dispositivos-service";

const state = {
  list: {},
  terminal: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, terminal) => {
    state.terminal = terminal;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then(role => {
      commit("SET_RESOURCE", role);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then(terminal => {
      commit("SET_RESOURCE", terminal);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then(terminal => {
      commit("SET_RESOURCE", terminal);
    });
  },

  activate({commit, dispatch}, params) {
    return service.activate(params, this.$axios)
      .then((descuento) => { commit('SET_RESOURCE', descuento); });
  },

  deactivate({commit, dispatch}, params) {
    return service.deactivate(params, this.$axios)
      .then((descuento) => { commit('SET_RESOURCE', descuento); });
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total,
  terminal: state => state.terminal,
  dropdown: state => {
    return state.list.map(terminal => ({
      id: terminal.id,
      nombre: terminal.nombre,
      abreviatura: terminal.abreviatura,
      paraderos: terminal.paraderos
    }));
  }
};

const terminales = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default terminales;
